import { useEffect } from 'react';
import { gate } from 'hub-http/gates';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getIsCallIncoming } from 'calling-internal-common/widget-status/operators/getCallState';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
import { Metrics, OPEN_REMOTE } from 'calling-remote-common/utils/Metrics';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
export const useOpenRemoteOnIncomingCall = openRemote => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const callStatus = getCallStatus(widgetDetails);
  const isCallIncoming = getIsCallIncoming(callStatus);
  const {
    gates
  } = useUserInfo();
  const {
    setShowProviderMenu,
    showProviderMenu
  } = useSelectedProviderContext();
  const isUngatedForRemoveLiveNotifications = gates.includes(gate('Calling:RemoveLiveNotifications'));
  useEffect(() => {
    if (showProviderMenu && isCallIncoming && isUngatedForRemoveLiveNotifications) {
      setShowProviderMenu(false);
    }
  }, [isCallIncoming, isUngatedForRemoveLiveNotifications, showProviderMenu, setShowProviderMenu]);
  useEffect(() => {
    if (isCallIncoming && isUngatedForRemoveLiveNotifications) {
      openRemote();
      Metrics.counter(OPEN_REMOTE, {
        source: 'incoming-call-remove-live-notification'
      }).increment();
    }
  }, [openRemote, isCallIncoming, isUngatedForRemoveLiveNotifications]);
};